import * as React from "react";
import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as styles from "./NewUserTask.scss";
import { confTask3,joinAndFinish,voteTicket } from "../../utils/fetch";
import {IEntrys,IUserInfo,IRanksInfo}  from "../../IViewObject";
import * as subpub from "../../utils/subpub";

export interface INewUserTaskProps {
  /** class */
  className?: string;
  userInfo:IUserInfo
  confData:IEntrys[]
  curBindUser:IRanksInfo;
  signCount:number
  
}
export interface INewUserTaskState{
    curIndex:number;
    confData:IEntrys[];
}

@pureRender
export class NewUserTask extends React.Component<INewUserTaskProps, INewUserTaskState> {
    private islogin=false;
    constructor(props){
        super(props);
        this.state={
            curIndex:0,
            confData:this.props.confData,
        }
    
    }
    componentWillMount(){
        window.Global.isLogin(()=>{
            this.islogin=true;
        })    
        
    }
    componentWillReceiveProps(nextProps) {
        this.setState({confData: nextProps.confData});
        this.forceUpdate()
    }
  public render() {
    const {　className } = this.props;

    const classNameSec = classnames(styles.sec, className);
    const {curIndex,confData} =this.state;
    return (
        <div className={classNameSec}>
            <ul className={styles.tasklist}>
                {confData.map((item,index)=>(this.renderGameTaskList(item,index)))}
            </ul>
            <div className={styles.gamesbox}>
                {confData.map((item,index)=>(this.renderGamsList(item,index)))}
            
            </div>
        </div>
     
    );
  }

//   渲染游戏列表
  private renderGamsList=(item,index)=>{
    if(!item.gameId) return; 
    let gameName=f2eGame.util.queryGame(item.gameId,"gameName");
    let recommensTips=f2eGame.util.queryGame(item.gameId,"recommendTips");
    let online=f2eGame.util.queryGame(item.gameId,"online");
    let onlineNum=String(online).split("");
    const {curIndex}=this.state;
    
    return (
        <div className={classnames(styles.games,styles["games"+(index+1)])} onClick={(e)=>this.chooseGame(index)}>
            <div className={styles.games_pic}>
                <img src={"http://lobby.dwstatic.com/goa/pic/o/"+item.gameId.toLowerCase()+"_76.png"} alt="" width="59" height="59"/>
                <div className={styles.game_pic_mask}></div>
            </div>
            <div className={styles.game_info}>
                <p className={styles.game_name}>
                    {gameName}
                </p>
                <p className={styles.games_desc}>
                    {recommensTips}
                </p>
                <div className={styles.games_num}>
                    {onlineNum.map((item,index)=>(this.renderOnlineNum(item,index)))}
                    <span>人玩</span>                        
                </div>
            </div>
            <div className={curIndex==index?styles.games_mask:""}></div>
        </div>
    )
  }

//   渲染在线人数
  private renderOnlineNum=(item,index)=>{
      return(
          <span className={styles.num}>{item}</span>
      )
  }

// 选择游戏
  private chooseGame(index){
    this.setState({curIndex:index})
  }

// 渲染不同游戏任务列表
  private renderGameTaskList=(item ,index)=>{
    if(!item.gameId) return; 
    const {curIndex}=this.state;
    const {signCount}=this.props;
    let classNameshow = classnames(styles['tasklist'+(index+1)]);
    if(curIndex==index){
        classNameshow = classnames(styles['tasklist'+(index+1)],styles.show);
    }
    let imgUrl=window.Global.baseNcImgUrl+"/awards/"+window.Global.AW+"/day"+(signCount+1)
    



    return(
        <li className={classNameshow}>        
            <div className={styles.tasklist_timetasks}>
                <span className={styles.task_name}>{item.tasks[0].showName}</span>         
                <img src={imgUrl+"/exprientawards/award"+(index+1)+".png"} alt="" height="95"/>   
                <div className={item.tasks[0].taskStatus==0?styles.btn_get:item.tasks[0].taskStatus==1?styles.btn_getting:styles.btn_got} onClick={(e)=>(this.getAward(item.tasks[0].id,item.gameId,item.serverId,item.tasks[0].showName,index,0))}></div>        
            </div>
            <div className={styles.tasklist_leveltasks}>
            <span className={styles.task_name}>{item.tasks[1].showName}</span>         
                <img src={imgUrl+"/levelawards/award"+(index+1)+".png"} alt="" height="95"/>   
                <div className={item.tasks[1].taskStatus==0?styles.btn_get:item.tasks[1].taskStatus==1?styles.btn_getting:styles.btn_got} onClick={(e)=>(this.getAward(item.tasks[1].id,item.gameId,item.serverId,item.tasks[1].showName,index,1))}></div> 
            </div>
        </li>
    )
  }

    //   领取奖励
    private  getAward(taskId,gameId,serverId,taskName,x,y){
        let options={
            taskId:taskId,
            gameId:gameId,
            serverId:serverId,
            taskName:taskName,
            x:x,
            y:y,
            noTips:false,
            isClick:true
        }
        if(this.islogin){
            subpub.emit('getTaskAward',options)
        }else{
            f2eGame.port.udb.login({
                type:"YYQ"
            })
        }

        
    }

}


export default NewUserTask;


// WEBPACK FOOTER //
// ./src/components/NewUserTask/NewUserTask.tsx